import { COLOR_AZUL_MAIN } from "../utils/const/colors-const";
import { STRING_COLOR_PRIMARIO } from "../utils/const/string-const";

const Modulo = (modulo) => {
  try {
    let primaryColor = COLOR_AZUL_MAIN;
    const mainColor = localStorage.getItem(STRING_COLOR_PRIMARIO);
    if (mainColor !== null) {
      primaryColor = mainColor;
    }
    const ruta = modulo.href;
    return (
      <div className="relative w-[320px] h-[150px]  rounded-2xl overflow-hidden "
        style={{ backgroundColor: primaryColor }}
        key={modulo.id}
      >
        <a href={ruta}>
          {/* Green background */}
          <div className={`absolute inset-0`} />

          <div className="absolute inset-0 bg-white  m-4
          rounded-tl-[180px] 
          rounded-tr-[150px] 
          rounded-bl-none 
          rounded-br-[150px]" />

          {/* Overlay content */}
          <div
            className="module-overlay absolute inset-0 flex items-center p-4 transition-all duration-300 hover:shadow-xl hover:scale-105"
          >
            <div className="flex items-center">
              <div className="text-2xl mr-3">
                {modulo.icono}
              </div>
              <div>
                <div className="font-bold text-lg">{modulo.titulo}</div>
                <div className="text-sm opacity-80">{modulo.descripcion}</div>
              </div>
            </div>
          </div>
        </a>
      </div>
      /*<div
        className="min-w-[320px] w-full md:w-1/2 lg:w-1/4"
        key={modulo.id}
      >
        <a href={ruta}>
          <div
            className="module-card rounded-lg  transition-all duration-300 hover:shadow-xl hover:scale-105"
            style={{
              backgroundImage: `url(${modulo.fondo})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              minHeight: '150px',
              position: 'relative',
              width: '100%',
              aspectRatio: '2/1'
            }}
          >
            <div
              className="module-overlay absolute inset-0 flex items-center p-4"
            >
              <div className="flex items-center">
                <div className="text-2xl mr-3">
                  {modulo.icono}
                </div>
                <div>
                  <div className="font-bold text-lg">{modulo.titulo}</div>
                  <div className="text-sm opacity-80">{modulo.descripcion}</div>
                </div>
              </div>
            </div>
          </div>
        </a>
      </div>*/
    );
  } catch (err) {
    console.log("Modulo err");
    console.log(err);
    return (
      <div>
        <label>{JSON.stringify(err)}</label>
      </div>
    );
  }
};

export default Modulo;